import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

export default class ModuleAnimatedText  {
	constructor(elm) {
        this.elm = elm;
        this.init();
	}

	init() {

        let mm = gsap.matchMedia();

        mm.add({
            isDesktop: `(min-width: 576px)`,
            isMobile: `(max-width: 575px)`,
            reduceMotion: "(prefers-reduced-motion: reduce)"
          }, (context) => {

            let { isDesktop, isMobile, reduceMotion } = context.conditions;

            if(reduceMotion) {
                return;
            }

            this.animatedElm = this.elm.querySelector('[data-animated-text]');
            new SplitText(this.animatedElm, { type: "lines" });

            ScrollTrigger.create({
                trigger: this.animatedElm,
                start: "bottom bottom",
                onToggle: self => {
                    if(self.isActive) {
                        this.elm.classList.add('u-module-animated-text--visible');
                    }
                },
            });

        });

	}

}
